import React from 'react';
import PropTypes from 'prop-types';
import StyledLoader from './Loader.style';

/**
 * @component Loader
 * Adding custom spinner svg to semantic UI Loader
 * Because no way found to customize their markup
 * AGIDS-347: loader default size should be 48x48 (large)
 */
const Loader = ({ children, size = 'large', ...rest }) => {
  return (
    <StyledLoader size={size} {...rest}>
      {children}
      <svg className="loader__circle" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="40" />
      </svg>
    </StyledLoader>
  );
};

Loader.propTypes = {
  size: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default Loader;
